if (typeof window.REACT_CONFIG === 'undefined') {
    window.REACT_CONFIG = {
        JSON_METHOD: 'GET',

        BASE_PATH: '',
        API_URL: 'http://localhost:3001',

        INIT: 'http://localhost:3001/init',

        ORDERS_ACTIVE: 'http://localhost:3001/orders/active',
        ORDERS_INACTIVE: 'http://localhost:3001/orders/inactive',
        ORDER_DETAILS: 'http://localhost:3001/orders/details',
        ORDER_REPEAT: 'http://localhost:3001/orders/repeat',
        ORDER_CENTRAL: 'http://localhost:3001/orders/redirectToCentral',
        ORDER_WAREHOUSE: '',
        ORDER_LISTNUMBER: '',
        ORDER_NEW_STATUS: '',
        ORDER_ADD_NOTE: "",
        ORDER_EDIT_NOTE: "",
        ORDER_DELETE_NOTE: '',
        ORDER_GET_FILES: '',

        BALANCE_LIST: 'http://localhost:3001/balance/list',

        ACCOUNT_SETTINGS: 'http://localhost:3001/settings',
        ACCOUNT_SETTINGS_BALANCE: '',

        RESELLER_FILES: 'http://localhost:3000/data/files-list.json',
        RESELLER_FILES_DOWNLOAD: 'http://localhost:3000/data/files-list.json',

        TRADER_COMMISSION_LIST: 'http://localhost:3000/data/trader-commission.json',

        TRADER_ADD: 'http://localhost:3001/trader/add',
        TRADERS_SHOW: 'http://localhost:3001/traders/show'
    };
}

export default window.REACT_CONFIG;